let inited = false;

module.exports = (rule, Promise) => {
	if (!inited) {
		let promise = new Promise(resolve => {
			rule.pm.handleEvent('@this', 'permissions_update', (ruleKeys) => {
				if (ruleKeys.some(key => ['member'].indexOf(key) !== -1 && rule.pm.hasAccess(key))) {
					setTimeout(() => resolve(true), 1000);
				}
			}, {
				prefix: 'rule_joinform_upgrade_oneclick'
			});
		});

		rule.pm.handleEvent('@parent ~.SitePage_Join', 'inited', (p, widget) => {
			let master_onPrepareTransaction = widget.onPrepareTransaction;

			widget.onPrepareTransaction = function (data) {
				if (rule.pm.member) {
					if (data === true) {
						promise.then(() => {
							widget.dispatchEvent('user_upgrage_oneclick');
						});

						return false;
					}
				}

				return master_onPrepareTransaction.apply(this, arguments);
			};
		}, {
			sync: true,
			prefix: 'rule_joinform_upgrade_oneclick'
		});

		inited = true;
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/guest/register-joinform-upgrade-oneclick.es.js